import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import {
  IMetaAdsUpdateRequest,
  IMetaAdsUpdateResponse,
} from "../../features/Campaigns/interface/metaAds";
import { useAuth } from "../helper/useAuth";

interface UseMetaAdsUpdateCampaignParams {
  campaignId: string | number;
  data: IMetaAdsUpdateRequest;
}

export const useMetaAdsUpdateCampaign = () => {
  const { selectedIntegration } = useAuth();

  return useMutation<
    IMetaAdsUpdateResponse,
    Error,
    UseMetaAdsUpdateCampaignParams
  >({
    mutationFn: ({ campaignId, data }) => {
      const url = API_CONFIG.path.metaAdsCampaignDetailUpdate.replace(
        ":id",
        campaignId.toString(),
      );
      const queryParams = { tracking_id: selectedIntegration?.value as string };
      return httpService.post<IMetaAdsUpdateResponse, IMetaAdsUpdateRequest>(
        url,
        data,
        queryParams,
      );
    },
  });
};
